/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateful
 */
import React, { PropTypes } from 'react';
import ColorPicker from 'components/UI/Form/Fields/ColorPicker'
import updateMultiLesson from 'controllers/lesson/updateMultiLesson'
import {fetchClassLesson} from 'containers/pages/ClassDetail//ducks'

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state={
      calendar_color: ''
    }
    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit(){
    const {dismiss, dispatch, classID, lesson_id_list, proceed, pagination, state} = this.props
    updateMultiLesson(classID, {lesson_id_list, calendar_color: this.state.calendar_color, conflict_tag: 'allLessonNotAdd'})
    .then((res) => {
      dispatch(fetchClassLesson(classID, {
        amount_per_page: pagination.itemsCountPerPage,
        current_page_number: pagination.activePage,
        after_today: state
      }))
      proceed()
    })
  }

  render() {
    const {dismiss} = this.props

    return (
      <div className='lesson-reset-color-content'>
        <div className='header text-center'>{__('Reset Color', 'lessonTable')}</div>
        <div className='content text-center'>{__('Lesson color will be displayed in the calendar, making it organized and easy to view', 'lessonTable')}</div>
        <ColorPicker className='text-center' value={this.state.calendar_color} onChange={(res)=>{this.setState({calendar_color: res})}} />
        <div className='text-center btn-wrapper'>
          <button className='btn btn-default' onClick={() => {dismiss()}}>{__('Cancel', 'lessonTable')}</button>
          <button className='btn btn-primary' onClick={this.onSubmit}>{__('Save', 'lessonTable')}</button>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/LessonEditColor/ModalContent.js